import { render, staticRenderFns } from "./SsoLogout.vue?vue&type=template&id=7b047582"
import script from "./SsoLogout.vue?vue&type=script&lang=js"
export * from "./SsoLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports